import { ConfirmButton } from "@/components/common/ConfirmButton";
import {
	getRunnerEnvironmentSources,
	runnerEnvironmentNoticesUrl,
	runnerEnvironmentSourcesUrl,
} from "@/lib/api";
import { ACTION_LINK_CLASS } from "@/lib/link-styles";
import { formatBytes } from "@/lib/format-bytes";
import { useRunnerDownloadInfo } from "./useRunnerDownloadInfo";

/**
 * デバイスに配る環境イメージ (agent・browser・secrets-proxy・robot) の対応するソース (GPL などのもの。アーキテクチャ共通の 1 つの tar) と
 * ライセンス表示のリンク。.deb のソースコードのリンクの後ろに「・」で続ける。
 * 環境イメージの版が未設定なら出さない。取得中も出さない (.deb のリンクを先に出す)。
 */
export function EnvironmentSourcesLink() {
	const { info, error, retry } = useRunnerDownloadInfo(
		getRunnerEnvironmentSources,
		"環境イメージのソースコードの情報の取得に失敗しました。",
	);
	if (error)
		return (
			<span
				style={{
					display: "inline-flex",
					flexWrap: "wrap",
					alignItems: "center",
					gap: 8,
					marginLeft: 8,
				}}
			>
				<span data-testid="runner-environment-sources-error" style={{ color: "var(--danger)" }}>
					{error}
				</span>
				<ConfirmButton
					label="再試行"
					loading={false}
					variant="secondary"
					size="sm"
					onClick={retry}
					data-testid="runner-environment-sources-retry"
				/>
			</span>
		);
	if (!info) return null;
	return (
		<>
			・
			<a
				href={runnerEnvironmentSourcesUrl()}
				download
				data-testid="runner-environment-sources"
				className={`whitespace-nowrap ${ACTION_LINK_CLASS}`}
			>
				環境イメージのソースコード ({formatBytes(info.sources.size)})
			</a>
			・
			<a
				href={runnerEnvironmentNoticesUrl()}
				download
				data-testid="runner-environment-notices"
				className={`whitespace-nowrap ${ACTION_LINK_CLASS}`}
			>
				ライセンス表示
			</a>
		</>
	);
}
